<template>
  <form class="form form-login" @submit.prevent="postLogin">
    <ion-segment mode="md" scrollable value="Login" @ionChange="goTo($event.target.value)">
      <ion-segment-button mode="md" value="Login">
        <ion-label>Logowanie</ion-label>
      </ion-segment-button>
      <ion-segment-button mode="md" value="Register">
        <ion-label>Rejestracja</ion-label>
      </ion-segment-button>
    </ion-segment>

    <slide-y-up-transition :duration="500" :delay="200">
      <div v-show="show" class="box-info text-center">Podaj dane użyte podczas rejestracji.</div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Numer telefonu</label>
        <div class="input-wrapper">
          <input v-model="user.phone_number"
                 v-mask="'XXXXXXXXX'"
                 type="tel"
                 :class="{'input-error' : errors.phone_number }"
                 placeholder="Podaj swój numer telefonu"
                 ref="phoneNumberInput"
                 required/>
        </div>
        <p class="error" v-if="errors.phone_number">{{ errors.phone_number[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Hasło</label>
        <div class="input-wrapper">
          <input v-model="user.password"
                 type="password"
                 :class="{'input-error' : errors.password }"
                 placeholder="Wpisz hasło"
                 required/>
        </div>
        <p class="error" v-if="errors.password">{{ errors.password[0] }}</p>
      </div>
    </slide-x-left-transition>

    <div class="form-group" v-if="errors.message">
      <p class="error">{{ errors.message }}</p>
    </div>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Zaloguj się</span>
    </ion-button>

    <p class="text-center text-gray-light mt-20" @click="goTo('RemindPassword')">Nie pamiętasz hasła?</p>
  </form>
</template>

<script>
  import goTo from '@/mixins/goto';
  import { mapGetters, mapState } from 'vuex';
  import { Capacitor } from '@capacitor/core';
  import Analytics from '@/services/Analytics';
  import { version } from '../../package.json';

  export default {
    name: 'FormLogin',
    mixins: [goTo],
    computed: {
      ...mapState({
        loading: state => state.auth.loading,
        errors: state => state.auth.errors,
        deviceToken: state => state.auth.deviceToken
      }),
      ...mapGetters('profile', ['getProfile']),
    },
    data() {
      return {
        show: false,
        user: {
          phone_number : '',
          password: '',
          version: '',
          platform: ''
        }
      }
    },
    mounted(){
      this.show = true;
      setTimeout(() => {
        this.$refs.phoneNumberInput.focus();
      },1000)
    },
    methods: {
      postLogin() {
        // append data
        this.user.deviceToken = this.deviceToken;
        this.user.version = version;
        this.user.platform = Capacitor.platform;

        //
        this.$store.dispatch('AUTH_LOGIN_REQUEST', this.user).then(() => {
          // mobile apps only
          if (Capacitor.platform !== 'web') {
            // custom logEvent
            Analytics.logEvent({name: "login", params: {'user_device_token': this.deviceToken}})
            //
          }

          // check if ASM needs to be redirected
          if(this.getProfile.asm_first_login == true){
            this.$router.push({name: 'AsmFirstLogin'}).catch(err => {})
          }else{
            // check if user needs to be redirected (GDPR)
            if(this.getProfile.redirect_to_agreements == true){
              this.$router.push({name: 'UserAgreements'}).catch(err => {})
            }else{
              // otherwise all users go to dashboard
              this.$router.push({name: 'Dashboard'}).catch(err => {})
              this.$store.dispatch('GLOBAL_TOAST','Zalogowano poprawnie.');
            }
          }
        })
      }
    }
  }
</script>